import { createMuiTheme } from "@material-ui/core";

const palette = {
    primary: {
        main: "#133C60",
    },
    text: {
        primary: "#263238",
    },
};

const IRBTheme = createMuiTheme({
    palette: {
        ...palette,
    },
    props: {
        MuiButton: {
            disableElevation: true,
            variant: "contained",
        },
        MuiAccordion: {
            elevation: 0,
        },
        MuiTextField: {
            fullWidth: true,
            margin: "dense",
            variant: "outlined",
        },
    },
    overrides: {
        MuiListItem: {
            root: {
                fontSize: "0.9rem",
                "&$selected": {
                    color: "white",
                    backgroundColor: palette.primary.main,
                },
            },
        },
        MuiInputBase: {
            root: {
                fontSize: "0.9rem",
                "&$disabled": {
                    color: "rgba(0, 0, 0, 0.55)",
                    backgroundColor: " rgba(0, 0, 0, 0.02)",
                },
            },
        },
        MuiTable: {
            root: {
                fontSize: "0.857rem",
            },
        },
        MuiChip: {
            root: {
                fontWeight: 500,
                fontSize: "0.8625rem",
                height: 26,
            },
            sizeSmall: {
                fontWeight: 500,
                fontSize: "0.759rem",
                height: 22,
            },
        },
    },
});

export { IRBTheme };
